import React, { ReactElement } from "react";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { StudyModel } from "../Models/StudyModel";
import { DataHelper } from "../Helpers/DataHelper";
import { MiniTTFMCurve } from "./MiniTTFMCurve";
import { LabelModel } from "../Models/LabelModel";
import { LargePreviewWindow } from "./LargePreviewWindow";
import { ClusterEvalModel } from "../Models/ClusterEvalModel";
import { Graft } from "../Models/Trigger/TriggerClasses";
import { ReferenceValuesModel } from "../Models/ReferenceValuesModel";
import { UploadDataHelper } from "../Helpers/SharedClasses";

export class MeasurmentThumbnail extends React.Component<
    {
        rowData: PreviewMeasurement,
        studySelected: StudyModel,
        dataHelper: DataHelper,
        detailed: boolean, 
        previewAvailable: boolean,
        context: string, 
        procedureId: string,
        isExpandable: boolean,
        expanded: ()=>void, 
        repairMeasurementsClicked: ()=>void, 
        draggable: boolean,
        orientationChanged?: (value :string) => void,
        parentRefresh?: () => void,
    },
    {
        largePreview: boolean,
        evaluationResult: ClusterEvalModel,
        meanFlow: number,
        pulsatilityIndex: number, 
        indexConfig: ReferenceValuesModel
    }
> {
    miniTTFMCurve: React.RefObject<MiniTTFMCurve>;
    popupRef: React.RefObject<LargePreviewWindow>;
    holderDiv: React.RefObject<HTMLDivElement>;
    currentData: any = null;
    constructor(props: any) {
        super(props);
        this.popupRef = React.createRef();
        this.holderDiv = React.createRef();
        this.miniTTFMCurve = React.createRef();
        let uploadHelper: UploadDataHelper = new UploadDataHelper();
        this.state = {
            largePreview: false,
            evaluationResult: new ClusterEvalModel(),
            meanFlow: Math.abs(this.props.rowData.mean as number)  *1000,
            pulsatilityIndex: (this.props.rowData.pI as number),
            indexConfig: uploadHelper.getDefaultIndexConfiguration(this.props.studySelected)
        }
    }

    static defaultProps = {
        //Set any properties that are optional when creating the component.
        context: "",
        previewAvailable: true,
        isExpandable: true,
        expanded: ()=>{},
        repairMeasurementsClicked: ()=> {},
        draggable: true,
        orientationChanged: null
      }

      onVisible = (element: Element, callback: (e:Element) => void) => {
        new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
              callback(element);
              observer.disconnect();
            }
          });
        }).observe(element);
    }
    
    componentDidMount(): void {
        //Put stuff here that you want to run the first time the component is loaded.
        
        // const draggable = document.getElementById('draggable-'+this.props.rowData.id);

        // draggable?.addEventListener('dragstart', (event) => {
        //      event?.dataTransfer?.setData('text/plain', (event?.target as any).id);
        // });
        if (this.holderDiv.current)
                this.onVisible(this.holderDiv.current, (e: Element) =>
                {
                    this.checkFlowValues();
                });


    }

    stringToColor(str: string): string {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = (hash*19) % 360;
        return `hsl(${hue}, 80%, 50%)`; // Here, we set the saturation to 100% and lightness to 75%
      }

    handleEvaluationResult = (resultDict: ClusterEvalModel) => {
        this.setState({
            evaluationResult:resultDict
        })
    };


    expandThumb = (e: any)=>
        {
            if (!e.target.classList.contains("imagingOrientationButton"))
            {
            if (this.props.procedureId !== "repair")
            {
            if (this.props.isExpandable)
                {


            this.setState({largePreview: true});
            if (this.props.expanded != null)
            {
                this.props.expanded();
            }
            e.stopPropagation();
                }
            }
        }
        }
    
refreshData = (callback: () => void)=>
    {
        if (this.props.rowData.id && !this.currentData)
        {
            // this.setState({
            //     dataLoaded: false
            // });
            if (this.props.rowData.indicesColorGraded && this.props.rowData.indexConfigurationId)
            {
                this.props.dataHelper.GetIndexConfig(this.props.studySelected.id as string,  this.props.rowData.indexConfigurationId, (indexConfig: ReferenceValuesModel)=>
                {
                    if (indexConfig)
                    {
                        this.setState({
                            indexConfig: indexConfig
                        });
                    }
                });
            }

            this.props.dataHelper.CallService("MiscData", "GetFlowData", {}, { studyId: this.props.studySelected.id, measurementId: this.props.rowData.id, measurementType: "Flow", procedureid: this.props.procedureId, tokenId: this.props.dataHelper.miscToken},  (measurementDataRaw: string)=>{
            this.currentData = {};

            if (measurementDataRaw)
            {
                this.currentData = JSON.parse(measurementDataRaw);
                callback();
            // this.addDataPoints( this.currentData, true, this.convertSecondsToDataPoints(this.props.measurementPreview.sweepPosition ?this.props.measurementPreview.sweepPosition : 0));
            // this.setState({
            //     axisSize: this.currentData["x"].length,
            //     cursorPosition: this.convertSecondsToDataPoints(this.props.measurementPreview.sweepPosition ?this.props.measurementPreview.sweepPosition : 0),
            //     dataLoaded: true  
            //  }, callback);
            // }else
            // {
            //     this.setState({
            //         errorMessage: "No flow measurement data found.",
            //         dataLoaded: true
            //      });
             }
        }, (errorVal: any) =>
        {
            // this.setState({
            //     errorMessage: "Unable to load measurement",
            //     dataLoaded: true
            //  });
            console.log("Error loading thumbnail data.")
        }, "GET", false);
        }
    }


    convertSecondsToDataPoints = (valueInSeconds: number) =>
        {
            let recordedLength = this.props.rowData.recordedLength;
            if (!recordedLength)
                recordedLength = 60.0;
            
            let sweepLength = this.props.rowData.sweepLength;
            if (!sweepLength)
                sweepLength = 5.0;
            // let sweepPosition = this.props.measurementPreview.sweepPosition;
            // if (!sweepPosition)
            //     sweepPosition = 0.0;
    
            let ratioSecondsToDataPoints = (this.currentData["x"].length/recordedLength);
    
            let posInDataPointsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;
            return posInDataPointsRelative;
            
        }

analyzeWindow = (dataFlow: number[], dataACI: number[], dataPI: number[], dataMean: number[], dataDF: number[], position: number, windowSize: number = 1000)=> {
        if (!dataFlow || dataFlow.length === 0) return { meanFlow: 0, pi: 0 };
        
        const start = Math.max(0, position - windowSize);
        const end = position;
        const flowValues = dataFlow.slice(start, end);
        const ACIValues = dataACI.slice(start, end);
        
        if (flowValues.length === 0) return { meanFlow: 0, pi: 0 };
       
        
        const peakSystolic = Math.max(...flowValues);
        const endDiastolic = Math.min(...flowValues);
        let meanFlowSubset = flowValues.reduce((acc, val) => acc + val, 0) / flowValues.length;
        let meanACISubset = ACIValues.reduce((acc, val) => acc + val, 0) / ACIValues.length;
        let pi = meanFlowSubset !== 0 ? (peakSystolic - endDiastolic) / Math.abs(meanFlowSubset) : 0;
        let dfOut: number = 0;
        position = Math.round(position);
        meanFlowSubset = dataMean[position >= dataMean.length ? dataMean.length-1 : position];
        meanACISubset = dataACI[position >= dataACI.length ? dataACI.length-1 : position];
        pi = dataPI[position >= dataPI.length ? dataPI.length-1 : position]/1000;
        if (dataDF)
        {
            dfOut = dataDF[position >= dataDF.length ? dataDF.length-1 : position];
        }else
            dfOut = this.props.rowData.dF as number;
        return { meanFlowSubset, pi, meanACISubset, dfOut };
    }


 adjustScrubber = (value: number) =>
    {
        if (!this.currentData?.BLUE || !this.currentData?.PI ) return;

        const { meanFlowSubset, pi:pulsatilityIndex } = this.analyzeWindow(this.currentData.BLUE, this.currentData.ACI, this.currentData.PI, this.currentData.RED, this.currentData.DF, value);

        
        this.setState({ 
            meanFlow: Math.abs(meanFlowSubset as any),
            pulsatilityIndex: Math.abs(pulsatilityIndex)
        }, ()=> {

    
    });
    }
 adjustScrubberInSeconds = (valueInSeconds: number) =>
    {
        // let recordedLength = this.props.measurementPreview.recordedLength;
        // if (!recordedLength)
        //     recordedLength = 60.0;
        // let sweepLength = this.props.measurementPreview.sweepLength;
        // if (!sweepLength)
        //     sweepLength = 5.0;
        // // let sweepPosition = this.props.measurementPreview.sweepPosition;
        // // if (!sweepPosition)
        // //     sweepPosition = 0.0;

        // let ratioSecondsToDataPoints = (this.state.axisSize/recordedLength);

        // let posInSecondsRelative = (recordedLength - valueInSeconds) * ratioSecondsToDataPoints;

        // let scrubberPosInDataPoints = this.state.axisSize;
        let posInDataPointsRelative = this.convertSecondsToDataPoints(valueInSeconds);
        this.adjustScrubber(posInDataPointsRelative);
    }

    checkFlowValues = () =>
    {
         if (this.props.rowData.sweepPosition || (this.props.rowData.indicesColorGraded && this.props.rowData.indexConfigurationId))
            {
                //if the sweep position is set then we expect a savedMean, savedPI and a savedACI to be populated.
                //if not then we need to calculate it by getting the flow measurement and calculating it.
                if (this.props.rowData.savedMean || this.props.rowData.savedPI)
                {
                    this.setState({
                    meanFlow: this.props.rowData.savedMean as number,
                    pulsatilityIndex: this.props.rowData.savedPI as number
                });
                }else
                {
                    //Oh no, looks like this was before we saved the mean after the cursor was changed. We need to recalculate.
                    this.refreshData(()=>{

                                

                                    this.adjustScrubberInSeconds(this.props.rowData.sweepPosition as number);//1000 is the default position of one full "screen" of data.

                                });
                }
            }else
            {
                 let meanValue= Math.abs((this.props.rowData.mean as number *1000));

                if (this.props.rowData.lastMean)
                  {
                      meanValue = Math.abs((this.props.rowData.lastMean as number));
                  }

              let piValue = this.props.rowData.pI;
              if (this.props.rowData.lastPI)
                  {
                      piValue = (this.props.rowData.lastPI as number);
                  }
                  
                this.setState({
                    meanFlow: meanValue,
                    pulsatilityIndex: piValue as number
                });
            }
    }

        generateMiniFlowThumbnail= (labelToUse: ReactElement, missingData: boolean): ReactElement =>
        {
           

             let meanValue= Math.abs(this.props.rowData.savedMean ? this.props.rowData.savedMean :  this.state.meanFlow);
             let piValue = this.props.rowData.savedPI ? this.props.rowData.savedPI : this.state.pulsatilityIndex;

                let lowerValue = this.state.indexConfig.meanLowerReferenceValue as number;
                let upperValue = this.state.indexConfig.meanUpperReferenceValue as number;

                let piLowerValue = this.state.indexConfig.piLowerReferenceValue as number;
                let piUpperValue =  this.state.indexConfig.piUpperReferenceValue as number;

                let meanflowColor = ( meanValue< lowerValue? this.state.indexConfig.meanGoodColor: meanValue > upperValue? this.state.indexConfig.meanWorstColor: this.state.indexConfig.meanBadColor);
                let piColor = "";
                if (piValue)
                    piColor = ( piValue< piLowerValue? this.state.indexConfig.piGoodColor: piValue > piUpperValue? this.state.indexConfig.piWorstColor: this.state.indexConfig.piBadColor) as string;
                
                let flowThumb =<div className={"tile-thumbnail-simple "}>
                  <div className={"meanflowThumbnail "}>{labelToUse}<div className={"thumbnail-primaryindex "} style={{backgroundColor: meanflowColor}}><div className="thumbTitle">MF</div><div>
                      {(meanValue ? meanValue : 0.0).toFixed(2)}</div></div>
                      <div className={"thumbnail-secondaryindex "} style={{backgroundColor: piColor}}><div className="thumbTitle">PI</div><div>
                      {(piValue ? piValue : 0.0).toFixed(2)}</div></div>
                      </div>
                      </div>;
                return flowThumb;
        }

        

    render() {
        let fullAnatomicalLocation = this.props.rowData.anatomicalLocations?.join("-") as string;
        if (!fullAnatomicalLocation)
          fullAnatomicalLocation = this.props.rowData.vessels?.join("-") as string;

        if (!fullAnatomicalLocation)
        {
            if (this.props.rowData != null && this.props.rowData.intuiGraft != null)
            {
                let anatomicalLocations: string[] = [];
                Graft.getGraftName(this.props.rowData.intuiGraft, anatomicalLocations);
                fullAnatomicalLocation = anatomicalLocations?.join('-');
            }
        }   
        const recordDate = new Date(this.props.rowData.recordDate as Date);
        const formattedTime = recordDate
        ? `${recordDate.getHours().toString().padStart(2, '0')}:` +
            `${recordDate.getMinutes().toString().padStart(2, '0')}:` +
            `${recordDate.getSeconds().toString().padStart(2, '0')}` : "";

        let tooltipValue = new Date(this.props.rowData.recordDate as Date)?.toTimeString();
        let labelValue = formattedTime;

        if (this.props.context === "searchpreview")
            {
                tooltipValue = fullAnatomicalLocation;
                labelValue = fullAnatomicalLocation;
            }
        

        let labelToUse = <div className={"tileAnatomicalLabel"} title={tooltipValue}>{labelValue}</div>;
        
        let itemOut: ReactElement = <></>;
        if (this.props.detailed)
        {

            if (this.props.procedureId === "repair" )
            {
                itemOut = <div className="missing-thumbnail">
                <div className="missingdataerror">
                    <img alt="Missing data" src="/noIMG.svg" title="Missing data" loading="lazy"/>
            <div>This procedure contains missing data files</div>
            </div>
            <div className="missingdatapreview">
            <div><button className="primaryButton" onClick={()=>{
                this.props.repairMeasurementsClicked();

            }}>Repair</button></div>
            </div>
            </div>;
            }
            else if (this.props.rowData.missingData)
            {
                let flowThumb =this.generateMiniFlowThumbnail(labelToUse,true);

                itemOut = <div className="missing-thumbnail">
                    <div className="missingdataerror">
                        <img alt="Missing data" src="/noIMG.svg" title="Missing data" loading="lazy"/>
                <div>Missing data</div>
                <div className="datafilenamecontainer"><span className="datafilename">{this.props.rowData.id}</span><span className="datafilenameextension">.dat</span></div>
                </div>
                <div className="missingdatapreview">
                {this.props.rowData.measurementType === "Flow" ?  flowThumb : <div>{fullAnatomicalLocation}</div>}
                <div>{this.props.rowData.measurementType}</div>
                </div>
                </div>;
            }else
            {
            if (this.props.rowData.measurementType === "Flow")
            {
                itemOut = <div className="flowThumb"><MiniTTFMCurve ref={this.miniTTFMCurve} parentGroup={this.props.context} procedureid={this.props.procedureId} studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></MiniTTFMCurve></div>;
            }
            if (this.props.rowData.measurementType === "Ecg")
            {
                itemOut = <div className="flowThumb"><MiniTTFMCurve parentGroup={this.props.context} procedureid={this.props.procedureId} color1="#4A90E2" yAxisVisible={false} xAxisVisible={false}  height={60} usefilling={false} subType="Ecg" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></MiniTTFMCurve></div>;
            }
            if (this.props.rowData.measurementType === "Aux")
            {
                itemOut = <div className="flowThumb"><MiniTTFMCurve parentGroup={this.props.context} procedureid={this.props.procedureId} color1="#4A90E2" yAxisVisible={false} xAxisVisible={false}  height={60} usefilling={false} subType="Aux" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></MiniTTFMCurve></div>;
            }
            if (this.props.rowData.measurementType === "TransitTrend")
            {
                itemOut = <div className="flowThumb"><MiniTTFMCurve parentGroup={this.props.context} procedureid={this.props.procedureId} color1="#4A90E2" yAxisVisible={false} xAxisVisible={false}  height={60} usefilling={false} subType="TransitTrend" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></MiniTTFMCurve></div>;
            }
            if (this.props.rowData.measurementType === "PWDopplers" || this.props.rowData.measurementType === "PWDoppler")
            {
                itemOut = <div className="flowThumb"><MiniTTFMCurve xAxisMax={500} parentGroup={this.props.context} procedureid={this.props.procedureId} color1="#0196C2" color2="#C0E8F2" color3="#2A6BFF" usefilling={false} subType="PWDopplers" studySelected={this.props.studySelected} dataReceiver={this.props.dataHelper} measurementPreview={this.props.rowData}></MiniTTFMCurve></div>;
            }
            else if (this.props.rowData.measurementType === "Imaging")
            {
                itemOut = <div className="imaging-thumbnail">
                    <img alt="Imaging preview"  src={this.props.dataHelper.hostAddress + "MiscData/GetImagingThumbnail?studyId=" + this.props.studySelected.id + "&measurementId=" +  this.props.rowData.id + "&procedureId=" +  this.props.procedureId+ "&tokenId=" +  this.props.dataHelper.miscToken} loading="lazy"/>
                    <div className="thumbnail-data-wrap">
                        {this.props.orientationChanged ?
                    <div className="thumbDataItem imagingOrientationSwitch toggleButtonsWraper">
                        <button className={"imagingOrientationButton primaryButton " + (this.props.rowData.orientation === "Transverse" ? "Pressed" : "")} onClick={(e)=>
                        {if (this.props.orientationChanged) this.props.orientationChanged("Transverse");  e.preventDefault();

                        }}>Transverse</button>
                        <button className={"imagingOrientationButton primaryButton " +  (this.props.rowData.orientation === "Longitudinal" ? "Pressed" : "")} onClick={(e)=>
                            {
                                if (this.props.orientationChanged) 
                                    this.props.orientationChanged("Longitudinal"); 
                                e.preventDefault();
                            }}>Longitudinal</button>
                    </div>
                    : <></>}
                    <div className="thumbDataItem thumbnail-date"><label>Date: </label>{new Date(this.props.rowData.recordDate as Date)?.toLocaleString()}</div>
                    <div className="thumbDataItem thumbnail-label"><label>Location: </label><span className="thumbnailContent">{fullAnatomicalLocation}</span></div>
                <div className="thumbDataItem thumbnail-label protocolStep"><label>Protocol step: </label><span className="thumbnailContent">{this.props.rowData.protocolStep}</span></div>
                    </div></div>;
            }
        }
        }else
        {
            if (this.props.rowData.missingData)
                {
                    itemOut = <div className="missing-thumbnail-simple">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="29" viewBox="0 0 80 72">
                                    <g id="Group_11270" data-name="Group 11270" transform="translate(0 -4)">
                                    <path id="Path_11899" data-name="Path 11899" d="M37.656,12.815a9.37,9.37,0,0,1,16.235,0L84.528,66.2A9.309,9.309,0,0,1,76.41,80.125H15.137A9.309,9.309,0,0,1,7.019,66.2Z" transform="translate(-5.773 -4.125)" fill="#f5db00"/>
                                    <path id="Union_100" data-name="Union 100" d="M5163-3972a5,5,0,0,1,5-5,5.136,5.136,0,0,1,3.957,1.945A4.762,4.762,0,0,1,5173-3972a5,5,0,0,1-5,5A5,5,0,0,1,5163-3972Zm0-17v-18a5,5,0,0,1,5-5,5,5,0,0,1,5,5v18a5,5,0,0,1-5,5A5,5,0,0,1,5163-3989Z" transform="translate(-5128 4034)"/>
                                    </g>
                                </svg>
                                <div className="missingLabel">Missing data</div>
                            </div>;
                }else
                {
                    if (this.props.rowData.measurementType === "Flow")
                    {
             
                        itemOut = <div ref={this.holderDiv}>{this.generateMiniFlowThumbnail(labelToUse, false)}</div>;
                      
                    }
                    else if (this.props.rowData.measurementType === "Imaging")
                    {
                      if (this.props.previewAvailable)
                          itemOut = <div className="imaging-thumbnail-simple">{labelToUse}<img alt="Imaging preview" src={this.props.dataHelper.hostAddress + "MiscData/GetImagingThumbnail?studyId=" + this.props.studySelected.id + "&measurementId=" + this.props.rowData.id + "&procedureId=" +  this.props.procedureId+ "&tokenId=" +  this.props.dataHelper.miscToken} loading="lazy"/></div>;
                        else
                          itemOut = <div className="imaging-thumbnail-simple">{labelToUse}<img alt="Imaging preview" src="/usimage.png" loading="lazy"/></div>;
                    }
                    else if (this.props.rowData.measurementType === "Ecg")
                    {
                        itemOut = <><div className="tile-thumbnail-simple thumbnail-other">ECG</div></>;// Mini Preview of ECG is blank <div className="imaging-thumbnail-simple">ECG</div>;
                    }
                    else if (this.props.rowData.measurementType === "Aux")
                    {
                        itemOut = <><div className="tile-thumbnail-simple thumbnail-other">AUX</div></>;// Mini Preview of ECG is blank <div className="imaging-thumbnail-simple">ECG</div>;
                    }
                     else if (this.props.rowData.measurementType === "TransitTrend")
                    {
                        itemOut = <><div className="tile-thumbnail-simple thumbnail-other">Trend</div></>;// Mini Preview of ECG is blank <div className="imaging-thumbnail-simple">ECG</div>;
                    }
                    else if (this.props.rowData.measurementType === "PWDopplers" || this.props.rowData.measurementType === "PWDoppler")
                    {
                        itemOut = <><div className="tile-thumbnail-simple thumbnail-other">PW Doppler</div></>;// Mini Preview of ECG is blank <div className="imaging-thumbnail-simple">ECG</div>;
                    }
                    else
                    {
                        itemOut = <div className="unknown-thumbnail-simple">Unknown</div>;
                    }
                }
        }
        let suggestedLabels: string[] = [];
          
        if (this.props.rowData.labels) {
            this.props.rowData.labels.forEach((label: LabelModel) => {
            suggestedLabels.push(label.name);
          });
        }

        // let uniqueLabels = Array.from(new Set(suggestedLabels));
        // let labelsStyled = <></>;
        // if (uniqueLabels) {
        //     labelsStyled =
        //     <div className="tagsWrapper">
        //       {uniqueLabels.map((label, index) => (
        //         <div key={index} className={"labelInDataGrid"} style={{backgroundColor: this.stringToColor(label)}}>
        //           {label}
        //         </div>
        //       ))}
        //     </div>
        
        // }
        let commentsItem =   this.props.rowData.otherComments ? 
                 <span className="commentsThumbnail" title={this.props.rowData.otherComments}>
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 31C0 30.7292 0.0416667 30.4479 0.125 30.1562C0.21875 29.8646 0.296875 29.5885 0.359375 29.3281C0.598958 28.3385 0.848958 27.3594 1.10938 26.3906C1.36979 25.4219 1.61979 24.4427 1.85938 23.4531C1.24479 22.3073 0.78125 21.1094 0.46875 19.8594C0.15625 18.6094 0 17.3333 0 16.0312C0 14.5625 0.1875 13.1458 0.5625 11.7812C0.947917 10.4062 1.48438 9.125 2.17188 7.9375C2.86979 6.75 3.70312 5.67188 4.67188 4.70312C5.65104 3.72396 6.73438 2.88542 7.92188 2.1875C9.10938 1.48958 10.3854 0.953125 11.75 0.578125C13.1146 0.192708 14.5312 0 16 0C17.4688 0 18.8802 0.192708 20.2344 0.578125C21.599 0.953125 22.875 1.48958 24.0625 2.1875C25.25 2.88542 26.3281 3.71875 27.2969 4.6875C28.276 5.65625 29.1146 6.73438 29.8125 7.92188C30.5104 9.10938 31.0469 10.3854 31.4219 11.75C31.8073 13.1042 32 14.5156 32 15.9844C32 17.4427 31.8073 18.8542 31.4219 20.2188C31.0469 21.5729 30.5156 22.8438 29.8281 24.0312C29.1406 25.2188 28.3125 26.3021 27.3438 27.2812C26.375 28.2604 25.2969 29.099 24.1094 29.7969C22.9323 30.4948 21.6667 31.0365 20.3125 31.4219C18.9583 31.8073 17.5469 32 16.0781 32C14.7865 32 13.5156 31.8542 12.2656 31.5625C11.0156 31.2604 9.81771 30.8125 8.67188 30.2188L1.23438 31.9688C1.13021 31.9896 1.05208 32 1 32C0.71875 32 0.479167 31.9062 0.28125 31.7188C0.09375 31.5208 0 31.2812 0 31ZM15.9375 30C17.2292 30 18.474 29.8333 19.6719 29.5C20.8698 29.1667 21.9896 28.6979 23.0312 28.0938C24.0729 27.4896 25.0208 26.7656 25.875 25.9219C26.7396 25.0677 27.474 24.1198 28.0781 23.0781C28.6927 22.0365 29.1667 20.9167 29.5 19.7188C29.8333 18.5208 30 17.276 30 15.9844C30 14.6927 29.8333 13.4531 29.5 12.2656C29.1667 11.0677 28.6927 9.95312 28.0781 8.92188C27.474 7.89062 26.7448 6.94792 25.8906 6.09375C25.0365 5.23958 24.0885 4.51042 23.0469 3.90625C22.0052 3.30208 20.8854 2.83333 19.6875 2.5C18.5 2.16667 17.2656 2 15.9844 2C14.7031 2 13.4635 2.16667 12.2656 2.5C11.0781 2.83333 9.96354 3.30208 8.92188 3.90625C7.89062 4.51042 6.94792 5.23958 6.09375 6.09375C5.25 6.9375 4.52083 7.875 3.90625 8.90625C3.30208 9.9375 2.83333 11.0521 2.5 12.25C2.16667 13.4375 2 14.6719 2 15.9531C2 16.6302 2.04167 17.2552 2.125 17.8281C2.20833 18.401 2.32812 18.9635 2.48438 19.5156C2.64062 20.0573 2.82812 20.599 3.04688 21.1406C3.26562 21.6823 3.51562 22.25 3.79688 22.8438C3.88021 23.0104 3.92188 23.1719 3.92188 23.3281C3.92188 23.4427 3.89062 23.6562 3.82812 23.9688C3.76562 24.2812 3.68229 24.6406 3.57812 25.0469C3.47396 25.4531 3.35938 25.8906 3.23438 26.3594C3.11979 26.8281 3.00521 27.276 2.89062 27.7031C2.77604 28.1302 2.67188 28.5208 2.57812 28.875C2.48438 29.2188 2.41667 29.474 2.375 29.6406C3.08333 29.474 3.78125 29.3073 4.46875 29.1406C5.16667 28.974 5.86979 28.8021 6.57812 28.625C6.93229 28.5417 7.30208 28.4427 7.6875 28.3281C8.07292 28.2135 8.44792 28.1562 8.8125 28.1562C8.89583 28.1562 8.97396 28.1719 9.04688 28.2031C9.11979 28.224 9.19792 28.25 9.28125 28.2812C9.84375 28.5417 10.3854 28.7812 10.9062 29C11.4375 29.2083 11.9688 29.3854 12.5 29.5312C13.0312 29.6771 13.5781 29.7917 14.1406 29.875C14.7031 29.9583 15.3021 30 15.9375 30ZM11 14C10.7292 14 10.4948 13.901 10.2969 13.7031C10.099 13.5052 10 13.2708 10 13C10 12.7292 10.099 12.4948 10.2969 12.2969C10.4948 12.099 10.7292 12 11 12H21C21.2708 12 21.5052 12.099 21.7031 12.2969C21.901 12.4948 22 12.7292 22 13C22 13.2708 21.901 13.5052 21.7031 13.7031C21.5052 13.901 21.2708 14 21 14H11ZM11 20C10.7292 20 10.4948 19.901 10.2969 19.7031C10.099 19.5052 10 19.2708 10 19C10 18.7292 10.099 18.4948 10.2969 18.2969C10.4948 18.099 10.7292 18 11 18H17C17.2708 18 17.5052 18.099 17.7031 18.2969C17.901 18.4948 18 18.7292 18 19C18 19.2708 17.901 19.5052 17.7031 19.7031C17.5052 19.901 17.2708 20 17 20H11Z" fill="black"/>
                </svg>
              </span>
                :
                <></>;
        return (
            
            
            <>
              { this.state.largePreview && <LargePreviewWindow parentRefresh={()=>
              {
                if (this.miniTTFMCurve &&  this.miniTTFMCurve.current)
                    this.miniTTFMCurve.current.adjustScrubberInSeconds(this.props.rowData.sweepPosition as number);
                if (this.props.parentRefresh)
                    this.props.parentRefresh();
                }} orientationChanged={this.props.orientationChanged} onEvaluationResult={this.handleEvaluationResult} ref={this.popupRef} rowData={this.props.rowData} dataHelper={this.props.dataHelper} procedureId={this.props.procedureId} studySelected={this.props.studySelected} closeClicked={()=>{
                  this.setState({largePreview: false});
              }} cachedEvalResutls={this.state.evaluationResult as ClusterEvalModel} ></LargePreviewWindow>}
            {
                this.props.draggable 
                ?
                <div id={"draggable-"+this.props.rowData.id} draggable="true" onDragStart={(event) =>
                {
                
                    event.dataTransfer.setData('text/plain', this.props.rowData.id);

                }
            } className={"thumbItem draggable " + (this.props.detailed ? "detailed" : "mini")} onClick={this.expandThumb}>
              {
                itemOut
              }
               {
                this.props.detailed  ?
              <div className="alertIcons">{commentsItem}</div> : <></>
              }
            </div>
                :
                <div className={"thumbItem nondraggable " + (this.props.detailed ? "detailed" : "mini")} onClick={this.expandThumb}> 
              {
                itemOut
              }
              <div className="alertIcons">

              {
              commentsItem
              }

              <span className="checkedThumbnail">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2.12109" y="6.36395" width="8" height="3" transform="rotate(45 2.12109 6.36395)" fill="white"/>
                <rect x="12.0205" y="3.53552" width="3" height="12" transform="rotate(45 12.0205 3.53552)" fill="white"/>
                </svg>
              </span>

              </div>
             
            </div>
            }
            
            </>
        );
    }
}
